  <h1 class="sr-only">Bulk Applicant Upload</h1>
  <h2 id="dialogTitle" mat-dialog-title>Upload Bulk Applicant Data</h2>
  <mat-divider></mat-divider>
  <mat-dialog-content>
    <!-- File Upload Bar -->
    <main>
      <div class="file-upload-bar">
        <div class="input-group mb-3">
          <label for="fileInput" class="sr-only"> Select .xlsx file to upload applicants</label>
          <input type="file" class="form-control" id="fileInput" (change)="onFileSelected($event)" accept=".xlsx">
          <!-- Added aria-label for clear button -->
          <button *ngIf="selectedFile" class="clear-btn" type="button" (click)="clearFile()" 
            aria-label="Clear selected file">
            <i class="fa-solid fa-circle-xmark"></i>
          </button>
          <button class="btn btn-primary" type="button" (click)="uploadFile()" [disabled]="!selectedFile">Upload Applicant Data File</button>
        </div>
        <!--  Added aria-live for success message -->
        <span *ngIf="isFileUploaded" class="upload-success-message"   aria-live="polite">
          File uploaded successfully. Click 'Submit' to process the data.
        </span>
        <div class="sample-file-link">
          <!-- Added aria-label to download link -->
          <a href="assets/bulk-upload-applicants-excel/sample-meck-valid-applicants.xlsx" *ngIf="isEligibilityAutoDetermined" download aria-label="Download sample Excel template for bulk applicant upload">
            <i class="fa fa-file-download"> </i>&nbsp; Download Sample Excel Template for Bulk Applicant Upload
          </a>
          <a href="assets/bulk-upload-applicants-excel/sample-rr-valid-applicants.xlsx" *ngIf="!isEligibilityAutoDetermined" download aria-label="Download sample Excel template for bulk applicant upload">
            <i class="fa fa-file-download"> </i>&nbsp; Download Sample Excel Template for Bulk Applicant Upload
          </a>
        </div>
      </div>
    </main>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="end">
    <button  mat-button mat-dialog-close (click)="submit()" [disabled]="!isFileUploaded" class="btn btn-primary">Submit Applicant Data</button>
    <button mat-button mat-dialog-close (click)="cancel()" class="btn modal-btn">Cancel</button>
  </mat-dialog-actions>